<template lang="pug">
expand-menu(v-model="expandMenu")
  template(#activator="{ on, attrs }")
    template(v-if="$user.isAuthenticated")
      profile-activator(
        v-model="expandMenu"
        v-bind="attrs"
        :mini="mini"
      )
    template(v-else)
      profile-activator(
        v-bind="attrs"
        :mini="mini"
        @click.native="$router.push('/login')"
      )
  v-list.redesignBlack--text.profile-menu-list
    template(v-for="(item, idx) in expandListItems")
      v-list-item(

        :key="idx"
        :to="item.to"
      )
        v-list-item-action
          v-icon(color="redesignBlack") {{ item.icon }}
        v-list-item-content
          v-list-item-title {{ item.text }}
    v-divider
    v-list-item(@click="$emit('exit')")
      v-list-item-action
        v-icon(color="redesignError") $iexit
      v-list-item-content
        v-list-item-title.redesignError--text(
        ) Выйти
</template>

<script>
import ExpandMenu from '../../ExpandMenu.vue';
import ProfileActivator from './ProfileActivator.vue';

export default {
  name: 'ProfileMenu',
  components: {
    ExpandMenu,
    ProfileActivator,
  },
  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandMenu: false,
    };
  },
  computed: {
    username() {
      const { ROLES } = this.$conf;
      if (this.$user.hasRoles([ROLES.organization])) {
        return this.$user.data.organizer.full_name;
      }
      if (this.$user.hasRoles([ROLES.operator])) {
        return this.$user.data.region.name;
      }
      if (this.$user.hasRoles([ROLES.department])) {
        return this.$user.data.department.name;
      }
      if (this.$user.hasRoles([ROLES.member, ROLES.trainer, ROLES.expert, ROLES.certificate])) {
        const middleName = this.$user.profile.middle_name ? `${this.$user.profile.middle_name.slice(0, 1)}.` : '';
        return `${this.$user.profile.last_name} ${this.$user.profile.first_name.slice(0, 1)}. ${middleName}`;
      }
      return this.$user.data.username;
    },
    expandListItems() {
      const { isMember, isExpert } = this.$user;
      const hasNoProfile = [this.$conf.ROLES.department, this.$conf.ROLES.admin, this.$conf.ROLES.operator];

      return [
        {
          icon: '$iuser',
          text: 'Мой профиль',
          to: `${isMember || isExpert ? '/redesign' : ''}/my-profile`,
          hidden: hasNoProfile.includes(this.$user.role.name),
        },
        {
          icon: '$ifolder-favorite-outline',
          text: 'Портфолио',
          to: `/redesign/my-portfolio`,
          hidden: !isMember,
        },
        {
          icon: '$iinfo',
          text: 'Инструкции',
          to: `${isMember ? '/redesign' : ''}/instructions`,
        },
      ].filter((item) => !item.hidden);
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  &__menu {
  }
  &__activator {
    height: 64px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    gap: 12px;
    border-radius: 8px;
    transition: all 0.2s;
    font-size: 16px;
    line-height: 17px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    &:hover {
      background: #f5f5f5;
    }
    &:active {
      background: #f0f0f0;
    }
  }
  &__expandIcon {
    transition: all 0.2s;
    &.active {
      transform: rotate(180deg);
    }
  }
}

.profile-menu-list {
  &::v-deep .v-list-item__action {
    margin-right: 12px;
  }
}
</style>
